module.exports = __webpack_public_path__ + "img/notification-bell.43e7a168.svg";